import {
  fireSys
} from '@/api/building'
const state = {
  buildingData: ''
}
const mutations = {
  FIRESYS(state, data) {
    state.buildingData = data
  }
}
const actions = {
  async fireSys({
    commit
  }, buildId) {
    const token = this.getters.token
    const {
      data: response
    } = await fireSys({
      token,
      buildId
    })
      .catch(err => {
        console.log(err)
      })
    commit('FIRESYS', response)
  }
}

export default {
  state,
  mutations,
  actions
}
